export default {
  location: '地点 ',
  south: '南半球 ',
  north: '北半球 ',
  	category: {
		fish: '鱼类',
		bugs: '昆虫类',
		furnitures: '家具类',
		villagers: '居民类',
		flowers: '杂交花攻略',
		deepsea: '海洋生物'
	},
	month: '月',
	monthPre: '',
	fishShadow: '鱼影 ',
	fishShadows: {
		Smallest: '特小',
		Small: '较小',
		Medium: '中偏小',
		Large: '中偏大',
		Larger: '较大',
		Largest: '特大',
	},
	fishLocation: '地点 ',
	fishLocations : {
		river: '河流',
		sea: '大海',
		pond: '池塘',
		clifftop: '悬崖',
		pier: '码头',
		riverMouth: '入海口',
	},
	placeholder: ' 输入名称搜索',
	rank:{
		HightoLow : '价格从高到低',
		LowtoHigh: '价格从低到高',
	},
	card: {
		random: "全天",
		common: "全年",
		price: "价格",
		time: '时间',
		month: '月份',
		fishShadow: '鱼影',
		fishLocation: '地点',
		diy: '需DIY',
		species: '种族',
		personality: '性格',
		birthday: '生日',
		deepSeaShadow: '影子'
		
	}
}